import { getEnvHost } from './environment';
import type { Env } from './types';

export const getDefaultHeaders: (env: Env, forceNewAuthHeaders?: boolean) => HeadersInit = (
  env,
  forceNewAuthHeaders,
) => ({
  'FFF-Auth': `V1.${forceNewAuthHeaders ? '2' : '1'}`,
  Origin: getEnvHost(env),
  'Content-Type': 'application/json; charset=utf-8',
});

export const spaHeaderOptions: Partial<RequestInit> = {
  credentials: 'include',
  redirect: 'manual',
};
